import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
  container: {
    textAlign: "center",
  },
}));

export const CircularStatic = () => {
  const classes = useStyles();
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <GridContainer justify="center" className={classes.container}>
      <div className="fa fa-spinner fa-spin"></div>
      <GridItem xs={12} sm={12} md={12}>
        <CircularProgress variant="static" value={progress} />
      </GridItem>
    </GridContainer>
  );
};
export default CircularStatic;
